module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.descricao,
        "value": Number(item.id)
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d3e0b63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdInputSwitch.vue
// module id = 1416
// module chunks = 45